export function resolveCoachAvatarSrc(coach) {
  return typeof src === 'string' ? src.trim() : '';

  // console.log('resolving source for avatar', coach, config);
  // const rawSrc = asString(coach?.persona?.avatar?.src).trim();
  // if (!rawSrc) return '';

  // if (/^https?:\/\//i.test(rawSrc)) {
  //   return rawSrc;
  // }

  // const pluginBaseUrl = asString(config?.pluginBaseUrl).trim();
  // if (!pluginBaseUrl) {
  //   return rawSrc;
  // }

  // return `${pluginBaseUrl.replace(/\/$/, '')}/${rawSrc.replace(/^\//, '')}`;
}

function asString(value) {
  return typeof value === 'string' ? value : '';
}
